import nanoid from 'nano-id'
import { homeUrl } from '../components/data'

export const myProject = [
    {
        id: nanoid(),
        title: "243 Studio Portfolio",
        description:"A Single page application that displays all the graphic design project I have worked on.",
        illustration:"https://github.com/243Studio/gif/raw/main/243studio.gif",
        technologies: ["Vanilla Javascript", "CSS & HTML"],
        link:"https://app.243studio.me",

        exp:"The project is a showcase all the works from 243 studio. Moving the mouse around allow the user to see all the works on over another. Clicking on an image will display more details about the project.",
        sourceCode: "https://github.com/243Studio/243studio",
        viewDemo:true  
    },
    {
        id: nanoid(),
        title: "Twitter Readability",
        description:"This is a simple project to help the user make a draft of his tweet before publishing it. It help the user know how many character he has typed, how many words he has typed and how many are left.",
        illustration:"https://github.com/243Studio/gif/raw/main/twitter.gif",
        technologies: ["Vanilla Javascript", "CSS & HTML"],
        link: homeUrl + "/Tweets-Count",
        exp:'The project analyze the inputed text, counts the number of characters, words, sentences and display the result of the Coleman-Liau Index of redability. It also allow the user to copy the text to the clipboard.',
        sourceCode: "",
        viewDemo:false
    },
    {
        id: nanoid(),
        title: "le petit piano de mag",
        description:"mag's little piano",
        illustration:"https://github.com/243Studio/gif/raw/main/pianonotes.png",
        technologies: ["React","Vanilla Javascript", "CSS & HTML"],
        link: homeUrl + "/pianonotes/",
        exp:"The project is a simple Piano emulator. When a button is clicked it plays the displayed note, with a piano sound.",
        sourceCode: "https://github.com/magmukendi/pianonotes/tree/master/pianonotes",
        viewDemo:false
    },
    {
        id: nanoid(),
        title: "Tenzi Game",
        description:"A Simple Tenzi Game",
        illustration:"https://github.com/243Studio/gif/raw/main/tenzi.gif",
        link: homeUrl + "/Tenzi-Game",
        technologies: ["React", "CSS & HTML"],
        exp:"The project display a button that when clicked will start the Tenzi game. Every time the user touch a shuffle button, it will shuffle the number on the card except for the card that have been selected by the user.\n\n For the user to be able to select a card he just need to click on it. The user will be given 60 seconds. If he is able to select all the identical number on the screen he will be congratulated with a we did it song.",
        sourceCode: "https://github.com/magmukendi/Tenzi-Game",
        viewDemo:false
    },
    
    {
        id: nanoid(),
        title: "Quicky Meme",
        description:"This is Meme generator. It allows the user to choose among famous random meme images and make a meme out of it in seconds. The user can also download the image if he wants or share it directly on social media.",
        illustration:"https://github.com/243Studio/gif/raw/main/meme.gif",
        link: homeUrl + "/quickymeme/",
        technologies: ["React", "CSS & HTML"],
        exp:"This project make an call to the imgflip API and fetch over 100 meme images and display it to the user.\n\nWe also have few buttons to help the user navigate from one image to another. If there is an image the appeal the user, he can then add a top text and a bottom text to the meme picture.\n\nIf the meme is what he was, he can directly download the image to his phone or PC.",
        sourceCode: "https://github.com/magmukendi/quickymeme",
        viewDemo:false  
    },
    {
        id: nanoid(),
        title: "Random Activities",
        description:"A web application that suggest the bored user what to do on that day",
        illustration:"https://github.com/243Studio/gif/raw/main/random.gif",
        link: homeUrl + "/random-activities/",
        technologies: ["React", "CSS & HTML"],
        exp:"This project give activities suggestion to the user. If the user click the button he will be prompted with another activity.",
        sourceCode: "https://github.com/magmukendi/random-activities",
        viewDemo:false  
    }
    /*{
        id: nanoid(),
        title: "WEPO Price Calculator",
        description:"A Price calculator for WEPO Product",
        illustration:"./projects/meme.gif",
        link: homeUrl + "/wepoPriceCalculator",
        sourceCode: "https://github.com/magmukendi/wepoPriceCalculator"  
    }*/
    
]

export const otherProject = [
    {
        id: nanoid(),
        title: "WEPO's mobile App",
        description:"A mobile application for buying and selling second hand products.",
        illustration:"./projects/meme.gif",
        link: homeUrl + "/memory-game",
        technologies: ["React","React native"],
        exp:"This project",
        sourceCode: "https://github.com/magmukendi/memory-game"  
    },
    {
        id: nanoid(),
        title: "Facebook Crawler",
        description:"A mobile application for buying and selling second hand products.",
        illustration:"./projects/meme.gif",
        link: homeUrl + "/memory-game",
        sourceCode: "https://github.com/magmukendi/memory-game"  
    },
    {
        id: nanoid(),
        title: "Cube Lab Mobile App",
        description:"A mobile application for buying and selling second hand products.",
        illustration:"./projects/meme.gif",
        link: homeUrl + "/memory-game",
        sourceCode: "https://github.com/magmukendi/memory-game"  
    },
    {
        id: nanoid(),
        title: "Memory Game",
        description:"A Memory Game with dog pictures",
        illustration:"./projects/meme.gif",
        link: homeUrl + "/memory-game",
        technologies: ["React", "CSS & HTML"],
        exp:"This project make an call to the imgflip API and fetch over 100 meme images and display it to the user.\n\nWe also have few buttons to help the user navigate from one image to another. If there is an image the appeal the user, he can then add a top text and a bottom text to the meme picture.\n\nIf the meme is what he was, he can directly download the image to his phone or PC.",
        sourceCode: "https://github.com/magmukendi/memory-game"  
    },
    
    
]


export const upcomingProjects = [
    {
        id: nanoid(),
        title: "243 Studio Portfolio Sites",
        description:"A Single page application that displays all the graphic design project I have worked on.",
        illustration:"./projects/meme.gif",
        link:"https://astonishing-piroshki-1236ad.netlify.app/",
        sourceCode: "https://github.com/243Studio/243studio"  
    },
    {
        id: nanoid(),
        title: "Congo Excellence",
        description:"A single page application with quizzes to help people know more about excellent things about Congo.",
        illustration:"./projects/meme.gif",
        link:"243studio.github.io/CongoExcellence",
        sourceCode: "https://github.com/243Studio/CongoExcellence"  
    },
    {
        id: nanoid(),
        title: "A Web application that let the user update a picture, put a text in to support the FARDC and share it on social media.",
        description:"A Single page application that displays all the graphic design project I have worked on.",
        illustration:"./projects/meme.gif",
        link:"243studio.github.io/CongoExcellence",
        sourceCode: "https://github.com/243Studio/SoutienFARDC"  
    },
    

]